<template>
  <div class="c-sticker-card">
    <div class="c-sticker-card__img-wrapper u-margin-bottom-small">
      <nuxt-img
        v-if="showSticker"
        v-bind="$getImgOptions(sticker, {
          format: 'webp',
          width: 100
        })"
      />
    </div>
    <p class="c-sticker-card__title t-heading-6 u-margin-bottom-small">
      {{ title }}
    </p>
    <template v-if="description">
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="c-sticker-card__description t-paragraph"
        v-html="description"
      />
      <!-- eslint-enable vue/no-v-html -->
    </template>
  </div>
</template>

<script>
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  mixins: [ UrlFilters ],
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    sticker: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    showSticker() {
      const sticker = this.sticker
      return !!sticker.src
    }
  }
}
</script>

<style lang="scss">
.c-sticker-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &__title {
    @include themify($themes) {
      color: themed('accent', 'base')
    }
    font-size: rem(18px);
  }
  &__description {
    max-width: rem(400px);
    font-size: rem(14px);
    text-align: center;
  }
  &__img-wrapper {
    border-radius: 100%;
    overflow: hidden;
    width: rem(100px);
    height: rem(100px);
    display: flex;
    align-items: center;
    justify-content: center;
    @include themify($themes) {
      background-color: themed('background', 'xx-light')
    }
    img {
      width: 100%;
    }
  }
}
</style>
